import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { InputLabel, Select } from '@material-ui/core';
import { ATIPOSERVICO_PRIVATIVO, ATIPOSERVICO_REGULAR, ATIPOSERVICO_SEMIPRIVATIVO } from 'consts';

const useStyles = makeStyles(theme => ({
    root: {},
    row: {
        height: '42px',
        display: 'flex',
        alignItems: 'left',
        marginTop: theme.spacing(1)
    },
    spacer: {
        flexGrow: 10
    },
    margin: {
        marginLeft: theme.spacing(2)
    },

}));

const ComboTipoServico = props => {
    const { className, ...rest } = props;
    const classes = useStyles();

    function Tipos() {
        const tipos = [
            { id: ATIPOSERVICO_REGULAR, descTipo: 'Regular' },
            { id: ATIPOSERVICO_PRIVATIVO, descTipo: 'Privativo' },
            { id: ATIPOSERVICO_SEMIPRIVATIVO, descTipo: 'Semi-privativo' }
        ];

        const listTipos = tipos.map(
            (tipo) => {
                return (                    
                    <option
                        key={tipo.id}
                        value={tipo.id}
                    >{tipo.descTipo}</option>
                )
            }
        )

        return (
            <div>
                <InputLabel
                    htmlFor="outlined-age-native-simple"
                >Tipo</InputLabel>
                <Select
                    fullWidth
                    inputProps={{
                        id: 'outlined-age-native-simple',
                        name: rest.name
                    }}
                    label={rest.label}
                    native
                    onChange={rest.onChange}
                    size
                    value={rest.value}
                >
                    {listTipos}
                </Select>
            </div>
        )
    }

    return (
        <Tipos />

    );
};

ComboTipoServico.propTypes = {
    className: PropTypes.string
};

export default ComboTipoServico;